// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setISOWeekYear as fn } from "../setISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setISOWeekYear = convertToFP(fn, 2);

// Fallback for modularized imports:
export default setISOWeekYear;
